import { render, staticRenderFns } from "./PageBack.vue?vue&type=template&id=56965583&scoped=true&"
import script from "./PageBack.vue?vue&type=script&lang=js&"
export * from "./PageBack.vue?vue&type=script&lang=js&"
import style0 from "./PageBack.vue?vue&type=style&index=0&id=56965583&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56965583",
  null
  
)

export default component.exports